<template>
  <app-custom-dialog
    :value="value"
    :title="item ? text(item.title) : ''"
    :is_translate="false"
    :title-icon="item ? icon(item.type) : null"
    :show-cancel="false"
    submit-text="close"
    width="520px"
    @input="$emit('input', $event)"
    @submit="$emit('input', false)"
  >
    <div v-if="item" slot="activator">
      <v-chip
        small
        label
        dark
        class="mb-3"
        :color="item.type === 'feature' ? 'primary' : 'blue-grey'"
      >
        {{ $t(`announcement_type_${item.type}`) }}
      </v-chip>
      <div class="announcement-body">{{ text(item.description) }}</div>
      <div class="text-caption grey--text mt-4">
        {{ (item.starts_at || item.created_at) | moment }}
      </div>
    </div>
  </app-custom-dialog>
</template>

<script>
import { localizedText, announcementIcon } from "@/utils/announcement";
import { myMixin } from "@/mixin/main";

export default {
  name: "AnnouncementDialog",
  mixins: [myMixin],
  props: {
    value: { type: Boolean, default: false },
    item: { type: Object, default: null },
  },
  methods: {
    text(map) {
      return localizedText(map, this.$i18n.locale);
    },
    icon: announcementIcon,
  },
};
</script>

<style scoped>
.announcement-body {
  white-space: pre-line;
  line-height: 1.6;
}
</style>
